import ApplicationComponent from "legacy/ApplicationComponent"
import AuthLauncher from "legacy/auth/AuthLauncher"
import PropTypes from "prop-types"
import React from "react"

// Note: $context is loaded globally

class SignInOrLogoutTitleSection extends ApplicationComponent {
  // $context currentUser|UserModel
  render() {
    if ($context.isPresent("currentUser")) {
      return (
        <div>
          <p>
            The {this.props.contextTitle} will be associated with the account{" "}
            {$context.currentUser.email}{" "}
            <a href="/users/sign_out?redirect_back=true">(not you? logout)</a>
          </p>
        </div>
      )
    } else {
      return (
        <p>
          Have a Dockwa account?{" "}
          <AuthLauncher type="login" customClass="inline" />
        </p>
      )
    }
  }
}

SignInOrLogoutTitleSection.propTypes = {
  contextTitle: PropTypes.string.isRequired,
}

export default SignInOrLogoutTitleSection
